// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2-kg6","errorLogs":"EditorFooter_errorLogs__20Jen"};